import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GenericField } from '../generic-field';
import { IVariableEntry } from "libraries/model/IVariableEntry";
import { IFieldSpecs } from '../interfaces/field-specs';

/**
 * @deprecated
 */
@Component({
    selector: 'rich-textarea-field-with-variables',
    template: `
        <rich-textarea-field [fieldConfig]="fieldConfig"
                             [label]="label"
                             [controlName]="controlName"
                             [required]="required"></rich-textarea-field>
        <variables-help *ngIf="variablesConfig && variablesConfig.canUseVariables && variablesConfig.help"
                        (onSelectVariable)="selectVariable()"
                        (onSelectVariableError)="selectVariable($event)"
                        [root]="variablesConfig && variablesConfig.help">
        </variables-help>
    `,
    styles: [`
        variables-help {
            display: block;
            margin-top: 5px;
        }
    `],
})
export class RichTextAreaFieldWithVariablesComponent extends GenericField {
    @Input()
    public variablesConfig: { canUseVariables: boolean, help: IVariableEntry } = null;
    @Input()
    public fieldConfig: IFieldSpecs;

    @Output()
    public readonly onSelectVariable: EventEmitter<null> = new EventEmitter();
    @Output()
    public readonly onSelectVariableError: EventEmitter<Error> = new EventEmitter();

    public selectVariable(error?: Error): void {
        if (error) {
            this.onSelectVariable.emit();
        } else {
            this.onSelectVariableError.emit(error);
        }
    }
}
